/**
 * Centralized utility for pushing events to the Google Tag Manager DataLayer.
 * Keeps React components clean and enforces standardized names/properties.
 */
import TagManager from 'react-gtm-module';

export const Analytics = {
    /**
     * Initialize GTM. Call this once in App.js.
     */
    init: () => {
        const gtmId = process.env.REACT_APP_GTM_ID || 'GTM-DEMO';
        TagManager.initialize({ gtmId });
        console.log(`[Analytics] GTM Initialized with ID: ${gtmId}`);
    },

    /**
     * Push a standard E-commerce event for GA4.
     * @param {string} eventName - e.g. 'view_item_list', 'add_to_cart', 'begin_checkout'
     * @param {object} ecommercePayload - Standard GA4 ecommerce object
     */
    pushEcommerceEvent: (eventName, ecommercePayload) => {
        if (!window.dataLayer) return;

        // Always push a null ecommerce object first to clear previous state in GTM
        window.dataLayer.push({ ecommerce: null });

        const payload = {
            event: eventName,
            ecommerce: ecommercePayload
        };

        window.dataLayer.push(payload);
        console.log(`[Analytics] Pushed Ecom Event: ${eventName}`, payload);
    },

    /**
     * Push a Custom Event for Operational Telemetry.
     * @param {string} eventName - e.g. 'artisan_onboarding_complete', 'job_completed'
     * @param {object} customParams - Key/value pairs to send with the event
     */
    pushCustomEvent: (eventName, customParams = {}) => {
        if (!window.dataLayer) return;

        const payload = {
            event: eventName,
            ...customParams
        };

        window.dataLayer.push(payload);
        console.log(`[Analytics] Pushed Custom Event: ${eventName}`, payload);
    }
};

export default Analytics;
